"use strict";

var _interopRequireDefault = require("/home/sphere-dev/Abroad/abroad-client/node_modules/@babel/runtime/helpers/interopRequireDefault.js")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("/home/sphere-dev/Abroad/abroad-client/node_modules/@babel/runtime/helpers/esm/classCallCheck.js"));

var _createClass2 = _interopRequireDefault(require("/home/sphere-dev/Abroad/abroad-client/node_modules/@babel/runtime/helpers/esm/createClass.js"));

var EmailSequencing = /*#__PURE__*/function () {
  function EmailSequencing(client) {
    (0, _classCallCheck2["default"])(this, EmailSequencing);
    this.client = client;
    this.resourceUrl = '/self-reflection';
  }

  (0, _createClass2["default"])(EmailSequencing, [{
    key: "getEmailUserData",
    value: function getEmailUserData(page, pageLimit) {
      for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
        args[_key - 2] = arguments[_key];
      }

      return this.client.get("".concat(this.resourceUrl, "/user-list?page=").concat(page, "&limit=").concat(pageLimit), args);
    }
  }, {
    key: "getUserEmailsDetails",
    value: function getUserEmailsDetails(userId) {
      for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        args[_key2 - 1] = arguments[_key2];
      }

      return this.client.get("".concat(this.resourceUrl, "/user/").concat(userId), args);
    }
  }]);
  return EmailSequencing;
}();

exports["default"] = EmailSequencing;